import { render, staticRenderFns } from "./AnalysisMultiPanel.vue?vue&type=template&id=56e96986&scoped=true"
import script from "./AnalysisMultiPanel.vue?vue&type=script&lang=js"
export * from "./AnalysisMultiPanel.vue?vue&type=script&lang=js"
import style0 from "./AnalysisMultiPanel.vue?vue&type=style&index=0&id=56e96986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e96986",
  null
  
)

export default component.exports